import axios from 'axios';
import { toast } from 'react-toastify';
import Cookies from 'js-cookie';


// Function to retrieve the auth token securely, e.g., from localStorage
const getAuthToken = () => {
    const token = Cookies.get('accessToken');
    return token;
};

export function copyObject(objects :object){
    return JSON.parse(JSON.stringify(objects));
}

export const apiCall = async (
        method : string,
        url : string,
        data : any = null,
        params : any = null,
        customHeaders = {},
        type :any = null
    ) => {
    try {
        // Ensure method is lowercase
        const lowerMethod = method.toLowerCase();

        // Base headers, extend as needed
        const headers  : any= {
            'Content-Type': 'application/json',
            ...customHeaders,
        };
        // Attach auth token if available
        const token = getAuthToken();
        if (token) {
            headers['Authorization'] = `Bearer ${token}`;
        }
        let apiurl = process.env.API_URL

        if(type == "capture"){
            apiurl =  process.env.API_CAPTURE_URL
        }
        const config : any= {
            method: lowerMethod,
            url: `${apiurl}${url}`,
            headers,
            //timeout: 10000, // Timeout after 10 seconds
        };

        // Handle FormData uploads
        if (data instanceof FormData) {
            delete headers['Content-Type']; // Let Axios set it correctly
            config.data = data;
        } else if (['get', 'post', 'put', 'patch', 'delete'].includes(lowerMethod) && data) {
            config.data = data;
        }

        // Attach query parameters if present
        if (params) {
            let paramsClone = {...params};
            // check if alert key is present in params and remove it
            if(Object.prototype.hasOwnProperty.call(paramsClone, 'alert')){
                delete paramsClone.alert;
            }
            config.params = paramsClone;
        }
        const response = await axios(config);

        if (response.data.message) {
            if(params?.alert !== false){
                toast.dismiss();
                toast.success(response.data.message);
            }
        }
        return response;
    } catch (error : any) {
        const errMsg = error.response ? error.response.data : error.message;
        console.log('error', errMsg);
        if (errMsg.code === 'ECONNABORT') {
            toast.error('Network error. Please check your internet connection.');
            return;
        }else if (errMsg.code === 'ECONNREFUSED') {
            toast.error('Server error. Please try again later.');
            return;
        }else {
            if(params?.alert !== false){
                let message = errMsg.message || errMsg || 'Something went wrong. Please try again.';
                if (typeof errMsg.message === 'object') {
                    message = errMsg.message[0];
                }
                toast.dismiss();
                toast.error(message);
            }
        }
    }
};

export function toggleDropdown(e: any) {
    let el = e.target;
    if(el.parentNode.getAttribute('data-dd') === 'open'){
        el.parentNode.removeAttribute('data-dd');
    }else{
        el.parentNode.setAttribute('data-dd', 'open');
    };
};

export function showLoader(status : boolean, text : string = ''){
    if (typeof document === 'undefined') return; // Exit if not in browser
    let wrapper = document.querySelector<HTMLElement>('.px_loader_wrapper');
    let textEl = document.querySelector<HTMLElement>('.px_loader_text');
    if(!textEl || !wrapper) return
    if (status == true) {
        wrapper.classList.add('show');
        textEl.innerText = text;
    } else {
        wrapper.classList.remove('show');
        textEl.innerText = '';
    }
}

export function getNameInitials(name : string) {
    const [firstName, lastName] = name ? name.split(" ").map(name => name.charAt(0)) : [];
    const nameinitials = lastName ? `${firstName}${lastName}` : firstName;
    return nameinitials?.toUpperCase();
}

export function confirmHelper(data:any, cb:any){
    const wrapperEl = document.querySelector<HTMLElement>('.px_confirm_wrapper');
    const titleEl = document.querySelector<HTMLElement>('.px_confirm_heading');
    const subtitleEl = document.querySelector<HTMLElement>('.px_confirm_subheading');
    const confirmButtonEl = document.querySelector<HTMLElement>('.px_confirm_submit');
    const cancelButtonEl = document.querySelectorAll<HTMLElement>('.px_confirm_cancel');

    if(!wrapperEl || !titleEl || !subtitleEl || !confirmButtonEl || !cancelButtonEl) return;

    titleEl.innerHTML = data?.title;
    subtitleEl.innerHTML = data?.message;
    confirmButtonEl.innerHTML = data?.buttonText;
    wrapperEl.classList.add('show');
    wrapperEl.classList.add(data?.type || 'delete');
    let confirm_callback = function(){
        cb(true);
        wrapperEl.classList.remove('show');
        confirmButtonEl.removeEventListener("click", confirm_callback);
        cancelButtonEl.forEach(element => {
            element.removeEventListener("click", cancel_callback);
        });
    };

    let cancel_callback = function(){
        cb(false);
        wrapperEl.classList.remove('show');
        confirmButtonEl.removeEventListener("click", confirm_callback);
        cancelButtonEl.forEach(element => {
            element.removeEventListener("click", cancel_callback);
        });
    };
    
    setTimeout(() => {
        confirmButtonEl.focus();
    }, 50);
    confirmButtonEl.addEventListener('click', confirm_callback);

    cancelButtonEl.forEach(element => {
        element.addEventListener('click', cancel_callback);
    });
}